var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('embed',{attrs:{"src":"/APK1.pdf","type":"application/pdf","width":"100%","height":"1000px"}})}
var staticRenderFns = []

export { render, staticRenderFns }